if (!customElements.get('product-size-guide')) {
  customElements.define(
    'product-size-guide',
    class extends HTMLElement {
      connectedCallback() {
        const source = this.querySelector('[data-size-guide-source]');
        const output = this.querySelector('[data-size-guide-output]');

        if (!source || !output || this.dataset.initialized) return;

        this.dataset.initialized = 'true';
        const sourceText = source.textContent.toUpperCase();
        const table = Array.from(source.querySelectorAll('table')).find((candidate) => {
          let ancestor = candidate.parentElement;

          while (ancestor && ancestor !== source) {
            if (ancestor.textContent.toUpperCase().includes('SIZE GUIDE')) return true;
            ancestor = ancestor.parentElement;
          }

          return sourceText.includes('SIZE GUIDE');
        });

        if (!table) return;

        let guideSection = table.parentElement;
        while (
          guideSection &&
          guideSection !== source &&
          !guideSection.textContent.toUpperCase().includes('SIZE GUIDE')
        ) {
          guideSection = guideSection.parentElement;
        }

        const tipScope = guideSection || source;
        const fitTip = Array.from(tipScope.querySelectorAll('p')).find((paragraph) =>
          /tip\s*:/i.test(paragraph.textContent)
        );
        const tableWrapper = document.createElement('div');
        tableWrapper.className = 'size-guide-table-wrap';
        tableWrapper.append(table.cloneNode(true));
        output.replaceChildren(tableWrapper);

        if (fitTip) {
          const fitTipClone = fitTip.cloneNode(true);
          fitTipClone.classList.add('size-guide-fit-tip');
          output.append(fitTipClone);
        }
      }
    }
  );
}
